import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import CarFridgeIcon from '@/components/UI/svg/DeltaPro/Icon/CarFridgeIcon';
import CoffeeMakerIcon from '@/components/UI/svg/DeltaPro/Icon/CoffeeMakerIcon';
import ElectricGrillIcon from '@/components/UI/svg/DeltaPro/Icon/ElectricGrillIcon';
import FanIcon from '@/components/UI/svg/DeltaPro/Icon/FanIcon';
import LaptopIcon from '@/components/UI/svg/DeltaPro/Icon/LaptopIcon';
import LightIcon from '@/components/UI/svg/DeltaPro/Icon/LightIcon';
import PhoneIcon from '@/components/UI/svg/DeltaPro/Icon/PhoneIcon';
import RefrigeratorIcon from '@/components/UI/svg/DeltaPro/Icon/RefrigeratorIcon';
import TVIcon from '@/components/UI/svg/DeltaPro/Icon/TVIcon';
import WiFiRouterIcon from '@/components/UI/svg/DeltaPro/Icon/WiFiRouterIcon';
import { createEFPic } from '@/utils/useEFPic';
import EFDelta2Icon10_2 from '@/components/UI/svg/Delta2/Icon/EFDelta2Icon10_2';
import EFDelta2Icon6_2 from '@/components/UI/svg/Delta2/Icon/EFDelta2Icon6_2';

const { EFPic } = createEFPic('/media/delta2/h5/');

export default function IconContent({}: any) {
    const { useLang, useRouter } = useGlobal();
    const { t } = useLang('delta2portablepowerstation');
    const { locale } = useRouter();

    const icons = [
        {
            id: 0,
            title: t('delta2.Phone'),
            wh: ['cn', 'tw'].includes(locale) ? '4000毫安时' : locale === 'cis' ? '11Вт' : '11Wh',
            hour: t('delta2.aniF_phone_num'),
            unit: t('delta2.aniF_unit1'),
            icon: <PhoneIcon />,
        },
        {
            id: 1,
            title: t('delta2.Laptop'),
            wh: locale === 'cis' ? '60Вт' : '60W',
            hour: t('delta2.aniF_laptop_num'),
            unit: t('delta2.aniF_unit1'),
            icon: <LaptopIcon />,
        },
        {
            id: 2,
            title: t('delta2.Light'),
            wh: locale === 'cis' ? '10Вт' : '10W',
            hour: t('delta2.aniF_light_num'),
            unit: t('delta2.aniG_msg11'),
            icon: <LightIcon />,
        },
        {
            id: 3,
            title: t('delta2.WiFiRouter'),
            wh: locale === 'cis' ? '10Вт' : '10W',
            hour: t('delta2.aniF_wifi_num'),
            unit: t('delta2.aniG_msg11'),
            icon: <WiFiRouterIcon />,
        },
        {
            id: 4,
            title: t('delta2.Fan'),
            wh: locale === 'cis' ? '40Вт' : '40W',
            hour: t('delta2.aniF_fan_num'),
            unit: t('delta2.aniG_msg11'),
            icon: <FanIcon />,
        },
        {
            id: 5,
            title: t('delta2.CarFridge'),
            wh: locale === 'ph' ? '1300W' : locale === 'cis' ? '60Вт' : '60W',
            hour: t('delta2.aniF_car_num'),
            unit: t('delta2.aniG_msg11'),
            icon: locale === 'ph' ? <EFDelta2Icon6_2 /> : <CarFridgeIcon />,
        },
        {
            id: 6,
            title: t('delta2.TV'),
            wh: locale === 'cis' ? '110Вт' : '110W',
            hour: t('delta2.aniF_tv_num'),
            unit: t('delta2.aniG_msg11'),
            icon: <TVIcon />,
        },
        {
            id: 7,
            title: t('delta2.Refrigerator'),
            wh: locale === 'cis' ? '120Вт' : '120W',
            hour: t('delta2.aniF_refrigerator_num'),
            unit: t('delta2.aniG_msg11'),
            icon: <RefrigeratorIcon />,
        },
        {
            id: 8,
            title: t('delta2.CoffeeMaker'),
            wh: locale === 'cis' ? '1000Вт' : '1000W',
            hour: t('delta2.aniF_coffee_num'),
            unit: t('delta2.aniF_unit2'),
            icon: <CoffeeMakerIcon />,
        },
        {
            id: 9,
            title: t('delta2.ElectricGrill'),
            wh: locale === 'ph' ? '1800W' : locale === 'cis' ? '1150Вт' : '1150W',
            hour: t('delta2.aniF_grill_num'),
            unit: t('delta2.aniF_unit2'),
            icon: locale === 'ph' ? <EFDelta2Icon10_2 /> : <ElectricGrillIcon />,
        },
    ];

    return (
        <div className={`${css.iconContent} iconContent GtmModuleData-section`} data-section-id={css.iconContent} data-section-title={t('delta2.Phone')}>
            <div className="icon-content">
                {icons.map((icon, index) => (
                    <div key={icon.id} className={`icon_item ${index < 5 ? 'line1' : 'line2'}`}>
                        <div className="icon_img">{icon.icon}</div>
                        <p className="t">
                            <span className="tInner">{icon.title}</span>
                        </p>
                        <p className="t">{icon.wh}</p>
                        <p className="h">
                            <strong className="font-family-bold">{icon.hour}</strong>
                            <span className="font-family-semibolder">{icon.unit}</span>
                        </p>
                    </div>
                ))}
                {['cn', 'tw'].includes(locale) && <p className="memo">{t('delta2.aniF_memo')}</p>}
                {['au'].includes(locale) && (
                    <div className="s-box light-box">
                        <div className="f-img">
                            <div className="img-wrapper">
                                <EFPic name={['protable_light.webp', 'protable_light.png']} />
                            </div>
                        </div>
                        <div className="f-text">
                            <div className="f-title">{t('delta2.aniM_msg1')}</div>
                            <div className="f-des">{t('delta2.aniM_msg2')}</div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}
